module.exports = __webpack_public_path__ + "../resources/img/ic_dashboard_refresh_mobile_light.683dafa2.svg";